export default __webpack_public_path__ + "static/media/gallery_00.735e5a44.jpg";